/**
 * themeAuth.ts
 * All values reference CSS custom properties so light/dark switching
 * via [data-theme="dark"] on <html> is handled automatically.
 */

export const colors = {
  // ── backgrounds ──────────────────────────────────────────────
  cream:      'var(--bg)',
  panel:      'var(--auth-panel-bg)',
  surface:    'var(--surface)',
  surface2:   'var(--surface2)',
  surface3:   'var(--surface3)',
  inputBg:    'var(--auth-input-bg)',
  sand:       'var(--accent-bg)',

  // ── text ─────────────────────────────────────────────────────
  ink:        'var(--text)',
  muted:      'var(--text2)',
  subtle:     'var(--text3)',

  // ── borders ──────────────────────────────────────────────────
  border:     'var(--border)',
  border2:    'var(--border2)',

  // ── accent / brand ───────────────────────────────────────────
  accent:     'var(--accent)',
  accentDk:   'var(--accent-dk)',
  accentBg:   'var(--accent-bg)',
  accentBd:   'var(--accent-bd)',
  accentRing: 'var(--accent-ring)',
  orange:     'var(--accent)',            // legacy alias (OTP highlights)
  darkOrange: 'var(--accent-dk)',         // legacy alias (error/warning text)

  // ── semantic ─────────────────────────────────────────────────
  success:    'var(--success)',
  successBg:  'var(--success-bg)',
  warning:    'var(--warning)',
  warningBg:  'var(--warning-bg)',
  danger:     'var(--danger)',
  dangerBg:   'var(--danger-bg)',

  // ── CTA button ───────────────────────────────────────────────
  ctaBg:      'var(--accent)',
  ctaColor:   'var(--accent-text)',
  ctaHover:   'var(--accent-dk)',

  // ── left-panel gradient (legacy) ─────────────────────────────
  heroFrom:   'var(--hero-from)',
  heroTo:     'var(--hero-to)',

  // ── elevation ────────────────────────────────────────────────
  shadowSm:   'var(--shadow-sm)',
  shadowMd:   'var(--shadow-md)',
  shadowLg:   'var(--shadow-lg)',

  // ── radii ────────────────────────────────────────────────────
  radiusSm:   'var(--radius-sm)',
  radiusMd:   'var(--radius-md)',
  radiusLg:   'var(--radius-lg)',
  radiusXl:   'var(--radius-xl)',
} as const

export type ThemeColors = typeof colors
